import { DivisionsTree } from '@gettactic/api';
import { Category } from '@v2/components/form/CategorySelect/types';
import { OfficeLabel } from '@cmp-src/data-display/labels/OfficeLabel';
import React from 'react';
import { DivisionLabel } from '@cmp-src/data-display/labels/DivisionLabel';

export const divisionAndOfficesToCategorySelectItems = (
  tree: DivisionsTree
): Category => {
  const items: Category = {
    name: React.createElement(DivisionLabel, { division: tree }),
    id: tree.id,
    children: [],
    keywords: [tree.name, tree.type],
    data: tree
  };

  if (tree.children) {
    for (const child of tree.children) {
      items.children?.push(divisionAndOfficesToCategorySelectItems(child));
    }
  }

  if (tree.offices) {
    for (const office of tree.offices) {
      items.children?.push({
        name: React.createElement(OfficeLabel, {
          office,
          iconClassName: 'text-neutral-1000'
        }),
        keywords: [office.name],
        id: office.id,
        data: office
      });
    }
  }

  return items;
};
